import React from 'react';
import {useTranslation} from 'react-i18next';
import '../hibuButton/hibuButton.scss';
import './hibuTooltip.scss';
import {OverlayTrigger, OverlayTriggerProps, Tooltip} from 'react-bootstrap';

type TooltipProps = {
    tooltipKey?: string;
    tooltipLabel?: string;
    placement?: any;
    translate?: boolean;
    delay?: number | {show: number; hide: number};
    defaultShow?: boolean;
    trigger?: OverlayTriggerProps['trigger'];
    hideOnClick?: boolean;
    children: Iterable<React.JSX.Element> | React.JSX.Element;
};

export const HibuTooltip = ({
    tooltipKey,
    tooltipLabel,
    placement,
    children,
    delay,
                                trigger = ['hover', 'focus', 'click'],
    translate = true,
    defaultShow = false,
                                hideOnClick = false,
}: TooltipProps) => {
    const {t} = useTranslation();
    const [show, setShow] = React.useState(defaultShow);
    const renderTooltip = () => (
        <Tooltip className="hibu-tooltip" id={'tooltip-' + tooltipKey}>
            {translate ? tooltipKey && t(tooltipKey) : tooltipKey}
            {tooltipLabel || ''}
        </Tooltip>
    );

    return (
        <OverlayTrigger
            delay={delay || 0}
            placement={placement || 'top'}
            trigger={trigger}
            overlay={renderTooltip()}
            show={hideOnClick ? show : undefined}
            defaultShow={hideOnClick ? undefined : defaultShow}
            onToggle={hideOnClick ? setShow : undefined}
        >
            <span onClick={hideOnClick ? () => setShow(false) : undefined}>{children}</span>
        </OverlayTrigger>
    );
};
